import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calculateTotalSearchPosition'
})
export class CalculateTotalSearchPositionPipe implements PipeTransform {

  transform(totalCount: number, pages: any[], pageIdx: number, matchIdx: number): string {
    let position = 0;
    for (let i = 0; i < pageIdx; i++) {
      position += pages[i].length;
    }
    position += matchIdx;
    position += 1;

    return `${position} / ${totalCount}`;
  }
}
